__webpack_require__.p = "/gujarati-typing/_next/";